import React from 'react';
import AIAssistantPanel from '../workspace/components/AIAssistantPanel';
import { useWorkspace } from '../workspace/WorkspaceContext';

export function EditorAIPanel() {
  const {
    bookId,
    selectedChapter,
    editor,
    handleAIAutoSaveRef,
    handleRequestChapterSwitch,
    setIsExternalWriting,
    loadVolumes,
    triggerDataRefresh,
    polishRequest,
    assistantRefs,
    handleRemoveAssistantRef,
    handleClearAssistantRefs,
  } = useWorkspace();

  return (
    <AIAssistantPanel
      open={true}
      onClose={() => { /* no-op */ }}
      bookId={bookId}
      chapter={selectedChapter}
      editor={editor}
      onAutoSave={() => handleAIAutoSaveRef.current?.()}
      onEditorLock={(locked) => setIsExternalWriting(locked)}
      onRequestChapterSwitch={handleRequestChapterSwitch}
      onChapterListRefresh={() => { void loadVolumes(); }}
      onWorldRefresh={triggerDataRefresh}
      polishRequest={polishRequest}
      assistantRefs={assistantRefs}
      onRemoveAssistantRef={handleRemoveAssistantRef}
      onClearAssistantRefs={handleClearAssistantRefs}
    />
  );
}
